<div class="body audit-body">
    
    <div class="section" *ngFor="let audit of (audit$|async)">

        <div class="headline">
            
            <mat-icon class="icon">play_arrow</mat-icon>
            <span class="text">Transaktion {{audit.transactionIdentifier|issueTransaction|async}} wurde ausgeführt</span>

        </div>

    </div>

</div>